module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-81d1eb5060977c7de5d5558075a80b9b.png";